import { defineComponent as _defineComponent } from 'vue'
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import AddGuest from '@/views/project-guests/components/AddGuest.vue';
import GroupIcon from '@/components/svg/group.svg?inline';
import { useProvideProjectGuests } from '@/views/project-guests/composables/useProjectGuests';
import MemberList from '@/views/project-guests/components/MemberList.vue';
import useProjectGuestState from '@/state/projectGuestState';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectGuests',
  setup(__props) {

useProvideProjectGuests();
const { loadGuests } = useProjectGuestState();

onMounted(() => {
  loadGuests();
});


return { __sfc: true,loadGuests, BCXContentArea, BCXBreadcrumbs, AddGuest, GroupIcon, MemberList }
}

})